module.exports = __webpack_public_path__ + "img/2024-10-16d_1.ea709cf6.jpg";